// extracted by mini-css-extract-plugin
export default {"location-pills":"styles__location-pills--g62Lk","filter-pills":"styles__filter-pills--IbTf3","icon-close":"styles__icon-close--IBptA"};